// Redo Supplies: theme JS (carousels, mobile search, cart badge)
(function () {
  // Carousel arrows: scroll by one card width
  document.querySelectorAll('.rs-carousel').forEach(function (section) {
    var track = section.querySelector('[data-carousel-track]');
    if (!track) return;
    function step() {
      var card = track.querySelector('.rs-card');
      return card ? card.getBoundingClientRect().width + 20 : 360;
    }
    var prev = section.querySelector('[data-carousel-prev]');
    var next = section.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  // Mega menu (Products): hover opens on desktop, click toggles, × / backdrop / Esc close
  var megaTrigger = document.querySelector('[data-mega-trigger]');
  var mega = document.querySelector('[data-mega]');
  if (megaTrigger && mega) {
    var megaBackdrop = document.querySelector('[data-mega-backdrop]');
    var megaClose = document.querySelector('[data-mega-close]');
    var closeTimer = null;
    function openMega() {
      clearTimeout(closeTimer);
      [mega, megaBackdrop, megaClose].forEach(function (el) { if (el) el.classList.add('is-open'); });
      megaTrigger.setAttribute('aria-expanded', 'true');
    }
    function closeMega() {
      clearTimeout(closeTimer);
      [mega, megaBackdrop, megaClose].forEach(function (el) { if (el) el.classList.remove('is-open'); });
      megaTrigger.setAttribute('aria-expanded', 'false');
    }
    function delayClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMega, 160);
    }
    megaTrigger.addEventListener('mouseenter', openMega);
    megaTrigger.addEventListener('mouseleave', delayClose);
    mega.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    mega.addEventListener('mouseleave', delayClose);
    megaTrigger.addEventListener('click', function (e) {
      if (megaTrigger.getAttribute('href') === '#') {
        e.preventDefault();
        mega.classList.contains('is-open') ? closeMega() : openMega();
      }
    });
    if (megaClose) megaClose.addEventListener('click', closeMega);
    if (megaBackdrop) megaBackdrop.addEventListener('click', closeMega);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMega(); });
  }

  // Shop category carousel: prev/next arrows + a scrollbar-style progress bar.
  // The thumb is sized to the visible fraction, so it stays honest whether 3
  // cards are in view (desktop) or 1 (mobile).
  document.querySelectorAll('.rs-shop').forEach(function (section) {
    var track = section.querySelector('[data-shop-track]');
    var bar = section.querySelector('.rs-shop-progress i');
    var prev = section.querySelector('[data-shop-prev]');
    var next = section.querySelector('[data-shop-next]');
    if (!track || track.children.length < 2) return;

    var step = function () {
      var card = track.children[0];
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    };

    var update = function () {
      var max = track.scrollWidth - track.clientWidth;
      var pct = max > 0 ? Math.min(1, Math.max(0, track.scrollLeft / max)) : 0;
      if (bar) {
        var ratio = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
        ratio = Math.min(1, Math.max(0.12, ratio));
        bar.style.width = ratio * 100 + '%';
        bar.style.transform = 'translateX(' + ((1 - ratio) / ratio) * pct * 100 + '%)';
      }
      // 1px of slack so rounding never leaves an arrow stuck enabled at the end
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;
    };

    var nudge = function (dir) {
      track.scrollBy({ left: dir * step(), behavior: 'smooth' });
      // Smooth scrolling settles after the click; refresh the arrow state then.
      setTimeout(update, 450);
    };
    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  // Explore list: hovering a collection swaps the photo beside it
  document.querySelectorAll('.rs-explore').forEach(function (section) {
    var items = section.querySelectorAll('[data-explore-item]');
    var photos = section.querySelectorAll('[data-explore-photo]');
    if (!items.length || photos.length < 2) return;
    var show = function (i) {
      photos.forEach(function (photo, n) {
        photo.classList.toggle('is-active', n === i);
      });
    };
    items.forEach(function (item, i) {
      item.addEventListener('mouseenter', function () { show(i); });
      item.addEventListener('focus', function () { show(i); });
    });
  });

  // Mobile bottom nav: flip to a floating white card once the page is scrolled
  var bottomnav = document.querySelector('.rs-bottomnav');
  if (bottomnav) {
    var onNavScroll = function () {
      if (window.scrollY > 24) bottomnav.classList.add('is-scrolled');
      else bottomnav.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onNavScroll, { passive: true });
    onNavScroll();
  }

  // Full-screen overlays: search panel and menu drawer.
  // Both open from the bottom nav and close on ×, Escape, or opening the other.
  var overlays = {
    search: document.querySelector('[data-searchpanel]'),
    drawer: document.querySelector('[data-drawer]'),
    filter: document.querySelector('[data-filterpanel]')
  };
  var openers = {
    search: document.querySelectorAll('[data-search-open]'),
    drawer: document.querySelectorAll('[data-drawer-open]'),
    filter: document.querySelectorAll('[data-filter-open]')
  };

  function closeOverlays() {
    Object.keys(overlays).forEach(function (key) {
      if (overlays[key]) overlays[key].classList.remove('is-open');
      openers[key].forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
    });
    document.body.style.overflow = '';
  }

  function openOverlay(key) {
    closeOverlays();
    if (!overlays[key]) return;
    overlays[key].classList.add('is-open');
    openers[key].forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
    // Lock the page behind the overlay so it doesn't scroll under the panel
    document.body.style.overflow = 'hidden';
    var input = overlays[key].querySelector('input[type="search"]');
    if (input) input.focus();
  }

  Object.keys(openers).forEach(function (key) {
    openers[key].forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openOverlay(key);
      });
    });
  });
  document.querySelectorAll('[data-overlay-close]').forEach(function (btn) {
    btn.addEventListener('click', closeOverlays);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeOverlays();
  });

  // Quote form: "None yet" is exclusive with the Redo product chips, and
  // picking it surfaces the note about quoting both standard and member price.
  var redoNone = document.querySelector('[data-redo-none]');
  if (redoNone) {
    var redoChips = [].slice.call(document.querySelectorAll('input[name="redo"]'));
    var redoNote = document.querySelector('[data-redo-note]');
    var syncRedo = function () {
      if (redoNote) redoNote.hidden = !redoNone.checked;
    };
    redoChips.forEach(function (chip) {
      chip.addEventListener('change', function () {
        if (chip === redoNone) {
          if (chip.checked) {
            redoChips.forEach(function (c) { if (c !== redoNone) c.checked = false; });
          }
        } else if (chip.checked) {
          redoNone.checked = false;
        }
        syncRedo();
      });
    });
    syncRedo();
  }

  // Product page: variant select updates displayed price
  document.querySelectorAll('select[name="id"]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var priceEl = document.querySelector('[data-product-price]');
      if (opt && priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
    });
  });

  // PDP: colour swatches set the active variant name; qty stepper.
  var swatchWrap = document.querySelector('[data-swatches]');
  if (swatchWrap) {
    var colorName = document.querySelector('[data-color-name]');
    swatchWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.rs-swatch');
      if (!btn) return;
      swatchWrap.querySelectorAll('.rs-swatch').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      if (colorName) colorName.textContent = btn.dataset.color;
      // swap the gallery to that colour's photo
      var img = document.querySelector('[data-gallery-img]');
      if (img && btn.dataset.img) {
        // The main image ships with a responsive srcset; browsers prefer srcset
        // over src, so it must be cleared or the picture never swaps.
        img.srcset = '';
        img.removeAttribute('sizes');
        img.src = btn.dataset.img;
        img.alt = (document.querySelector('.rs-pdp-info h1') || {}).textContent + ' in ' + btn.dataset.color;
      }
      var variantInput = document.querySelector('[data-variant-id]');
      if (variantInput && btn.dataset.variant) variantInput.value = btn.dataset.variant;
      var priceEl = document.querySelector('[data-product-price]');
      if (priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
    });
  }
  // Quantity is in cases, so show what that actually costs and how many units it is.
  var qtyEl = document.getElementById('qty');
  var info = document.querySelector('.rs-pdp-info');
  var totalEl = document.querySelector('[data-qty-total]');

  function activeCasePrice() {
    var active = document.querySelector('.rs-swatch.is-active');
    var raw = (active && active.dataset.price) || (info && info.dataset.casePrice) || '';
    var n = parseFloat(String(raw).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : n;
  }
  function updateTotal() {
    if (!totalEl || !qtyEl) return;
    var q = Math.max(1, parseInt(qtyEl.value, 10) || 1);
    qtyEl.value = q;
    var price = activeCasePrice();
    if (q < 2 || !price) { totalEl.hidden = true; return; }
    var units = parseInt(info && info.dataset.caseUnits, 10);
    var parts = [q + ' cases', '$' + (price * q).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })];
    if (units) parts.push((q * units).toLocaleString('en-US') + ' units');
    totalEl.textContent = parts.join(' \u00b7 ');
    totalEl.hidden = false;
  }
  document.querySelectorAll('.rs-qty button[data-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!qtyEl) return;
      qtyEl.value = Math.max(1, (parseInt(qtyEl.value, 10) || 1) + parseInt(b.dataset.step, 10));
      updateTotal();
    });
  });
  // Some products price colours differently (Poly Mailers 10x13 is $88 white, $98
  // beige), so the per-unit figure has to follow the swatch, not just the case price.
  var unitEl = document.querySelector('[data-unit-price]');
  function updateUnitPrice() {
    if (!unitEl) return;
    var units = parseInt(info && info.dataset.caseUnits, 10);
    var price = activeCasePrice();
    if (!units || !price) { unitEl.hidden = true; return; }
    var per = price / units;
    unitEl.textContent = '$' + per.toFixed(per >= 1 ? 2 : 3) + ' / unit';
    unitEl.hidden = false;
  }

  if (qtyEl) { qtyEl.addEventListener('input', updateTotal); qtyEl.addEventListener('change', updateTotal); }
  if (swatchWrap) swatchWrap.addEventListener('click', function () {
    setTimeout(function () { updateTotal(); updateUnitPrice(); }, 0);
  });
  updateTotal();
  updateUnitPrice();
  // Gallery thumbnails removed: the colour swatches are the single image picker,
  // so there's no second control to fall out of sync with the selected colour.

  // Keep cart badge fresh after add-to-cart round-trips.
  // An always-on red "0" reads as an error, so the badge hides when empty.
  function paintCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }
  document.querySelectorAll('[data-cart-count]').forEach(function (el) {
    el.hidden = !parseInt(el.textContent, 10);
  });
  if (document.querySelector('[data-cart-count]') && window.fetch) {
    fetch('/cart.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) paintCartCount(cart.item_count); })
      .catch(function () {});
  }

  // AJAX add-to-cart. A full-page form submit navigates away the instant you
  // click, which is a race against the Web Pixel emitting product_added_to_cart,
  // so that AddToCart event was unreliable. Posting to /cart/add.js in the
  // background fires the event every time (Shopify instruments the AJAX cart API)
  // and skips the jarring reload. Guarded to the live site; the static preview
  // has no cart server. Purchase tracking is unaffected either way (checkout).
  var cartForm = document.querySelector('form[action*="/cart/add"]');
  if (cartForm && window.fetch && location.protocol !== 'file:') {
    var errEl = null;
    cartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = cartForm.querySelector('[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (errEl) errEl.hidden = true;
      if (btn) { btn.disabled = true; btn.dataset.busy = '1'; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(cartForm) })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && res.body.description) || 'Could not add to cart.');
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { paintCartCount(cart.item_count); });
        })
        .then(function () {
          if (btn) { btn.textContent = 'Added ✓'; }
          setTimeout(function () { if (btn) { btn.textContent = label; btn.disabled = false; delete btn.dataset.busy; } }, 1800);
        })
        .catch(function (err) {
          if (btn) { btn.textContent = label; btn.disabled = false; delete btn.dataset.busy; }
          if (!errEl) {
            errEl = document.createElement('p');
            errEl.className = 'rs-cart-error';
            (cartForm.querySelector('.rs-pdp-actions') || cartForm).appendChild(errEl);
          }
          errEl.textContent = err.message;
          errEl.hidden = false;
        });
    });
  }
})();
